export abstract class OnAuthorizedHandler {
  abstract handle(): void;
}
